<ion-card class="loadingError">
    <ion-skeleton-text [animated]="true"></ion-skeleton-text>
</ion-card>
